document.addEventListener('DOMContentLoaded', function() {
    const breadcrumbs = document.querySelector('#breadcrumbs');
    if (!breadcrumbs) {
        return;
    }

    const nextElement = breadcrumbs.nextElementSibling?.querySelector(
            'div:first-child') ??
        breadcrumbs.nextElementSibling;
    if (!nextElement) {
        return;
    }

    const darkClasses = [
        'wp-block-create-block-tankbar-multiblock',
    ];

    const hasDarkClass = darkClasses.some(cls => nextElement.classList.contains(
        cls));

    if (hasDarkClass) {
        breadcrumbs.classList.add('text-white');
    } else {
        breadcrumbs.classList.remove('text-white');
    }
});
//# sourceMappingURL=breadcrumbs.js.map
